// 引入mock模块
import Mock from 'mockjs'

Mock.mock('/left-one', {
  time: 2.5,
  value: 60
})

Mock.mock('/left-top', {
  xData: ['2021-07', '2022-11', '2022-09', '2021-10', '2021-11', '2021-12', '2022-01', '2022-02', '2022-03', '2022-04', '2022-05'],
  yData: [7.0, 6.9, 9.5, 14.5, 18.4, 21.5, 25.26, 27, 28.3, 29.8, 31],
  name: '数据量 TB(单位)'
})

Mock.mock('/left-bottom', {
  data: [{
    name: '设备看板',
    used: 20,
    noused: 80
  },
  {
    name: '设备维修',
    used: 7,
    noused: 93
  },
  {
    name: '设备保养',
    used: 6,
    noused: 94
  },
  {
    name: '设备报修',
    used: 20,
    noused: 80
  },
  {
    name: '设备清单',
    used: 11,
    noused: 89
  },
  {
    name: '领退料',
    used: 7,
    noused: 93
  },
  {
    name: '知识库',
    used: 6,
    noused: 94
  },
  {
    name: '仓库任务',
    used: 5,
    noused: 95
  },
  {
    name: '设备点检',
    used: 12,
    noused: 88
  },
  {
    name: '入库',
    used: 3,
    noused: 97
  },
  {
    name: '停机记录',
    used: 3,
    noused: 97
  }
  ]
})

Mock.mock('/middle-top', {
  data: [{
    name: 'APP下载量',
    value: '09652',
    unit: '次'
  },
  {
    name: '连接设备',
    value: '03853',
    unit: '台'
  },
  {
    name: '设备总数量',
    value: '12535',
    unit: '台'
  }
  ],
  banner: [
    '/static/img/banner/banner1.jpg',
    '/static/img/banner/banner2.jpg',
    '/static/img/banner/banner3.jpg',
    '/static/img/banner/banner4.jpg',
    '/static/img/banner/banner5.jpg',
    '/static/img/banner/banner6.jpg'
  ]
})

Mock.mock('/right-bottom-honor', {
  banner: [
    '/static/img/honor/5.png',
    '/static/img/honor/1.png',
    '/static/img/honor/2.png',
    '/static/img/honor/3.png',
    '/static/img/honor/6.png',
    '/static/img/honor/8.png',
    '/static/img/honor/9.png',
    '/static/img/honor/10.png'
  ]
})

Mock.mock('/middle-bottom', {
  data: [{
    boot: '大洋精锻',
    active: '斯凯奇',
    service: '怡通控制',
    click: '海通机械',
    maintenance: '富源油箱'
  },
  {
    boot: '斯凯奇',
    active: '圣泰阀门',
    service: '盐电阀门',
    click: '天意密封',
    maintenance: '国投新材料'
  },
  {
    boot: '圣泰阀门',
    active: '阿现特',
    service: '昊芯科技',
    click: '国投新材料',
    maintenance: '健牌科技'
  },
  {
    boot: '恒康机电',
    active: '大洋精锻',
    service: '锐克斯研磨',
    click: '富源引擎',
    maintenance: '天意密封'
  },
  {
    boot: '阿现特',
    active: '盐电阀门',
    service: '海通机械',
    click: '锐克斯研磨',
    maintenance: '大洋精锻'
  }
  ]
})

Mock.mock('/right-top', {
  online: 2564,
  value: '20'
})

Mock.mock('/right-middle', {
  xData: ['2021-08', '2021-09', '2021-10', '2021-11', '2021-12', '2022-01', '2022-02', '2022-03', '2022-04', '2022-05', '2022-06'],
  yData: [32, 25, 35, 41, 51, 48, 38, 39, 55, 56, 59],
  name: '开机率 百分比(单位)'
})

Mock.mock('/right-bottom', {
  data: [{
    name: '电子',
    value: 29
  },
  {
    name: '汽车',
    value: 42
  },
  {
    name: '新能源',
    value: 27
  },
  {
    name: '机械',
    value: 23
  },
  {
    name: '纺织',
    value: 23
  },
  {
    name: '其他',
    value: 27
  }
  ]
})

Mock.mock('/left-top-two', {
  data: [{
    value: 2139,
    name: '订单数量',
    desc: '个',
    last: 200 
  },
  {
    value: 1067,
    name: '对接工厂数',
    desc: '家',
    last: 151
  },
  {
    value: '116928',
    name: '对接订单金额',
    desc: '万',
    last: 8603
  }
  ]
})

Mock.mock('/left-middle-two', {
  data: [{
    value: 124,
    name: '机加工'
  },
  {
    value: 32,
    name: '锻铸造'
  },
  {
    value: 30,
    name: '设备'
  },
  {
    value: 8,
    name: '纺织'
  },
  {
    value: 9,
    name: '电子信息'
  },
  {
    value: 10,
    name: '注塑'
  },
  {
    value: 16,
    name: '原料'
  },
  {
    value: 58,
    name: '其他'
  }
  ]
})

Mock.mock('/left-mid-two', {
  data: [{
    value: 45,
    name: '电子信息'
  },
  {
    value: 30,
    name: '汽车'
  },
  {
    value: 70,
    name: '新能源'
  },
  {
    value: 27,
    name: '其他'
  }
  ]
})

Mock.mock('/left-bottom-two', {
  value: {
    num1: '150',
    num2: '200万+'
  },
  data: [{
    name: '设备联网率',
    used: 20,
    noused: 80
  }]
})

Mock.mock('/middle-top-two', {
  data: [{
    name: '注册工厂',
    value: '11473',
    unit: '家'
  },
  {
    name: 'APP数量',
    value: '00332',
    unit: '个'
  },
  {
    name: '连接工厂',
    value: '00915',
    unit: '家'
  },
  {
    name: '连接设备',
    value: '32431',
    unit: '台'
  }
  ]
})

Mock.mock('/middle-two', {
  data: [{
    name: '重点工业互联网平台',
    children: [{
      name: '亭湖区',
      value: [120.246213, 33.443293],
      num: 1
    },
    {
      name: '盐都区',
      value: [120.089022, 33.301817],
      num: 2
    },
    {
      name: '开发区',
      value: [120.27257, 33.359336],
      num: 1
    }
    ]
  },
  {
    name: '工业互联网标杆工厂',
    children: [{
      name: '亭湖区',
      value: [120.430545, 33.572278],
      num: 1
    },
    {
      name: '大丰区',
      value: [120.588328, 33.453696],
      num: 2
    },
    {
      name: '开发区',
      value: [120.215407, 33.358404],
      num: 1
    }
    ]
  },
  {
    name: '省示范智能工厂',
    children: [{
      name: '盐都区',
      value: [120.051513, 33.31153],
      num: 1
    },
    {
      name: '开发区',
      value: [120.217395, 33.379493],
      num: 1
    }
    ]
  },
  {
    name: '省示范智能车间',
    children: [{
      name: '亭湖区',
      value: [120.200641, 33.355358],
      num: 4
    },
    {
      name: '盐都区',
      value: [120.188071, 33.317884],
      num: 9
    },
    {
      name: '大丰区',
      value: [120.503164, 33.226186],
      num: 3
    },
    {
      name: '滨海县',
      value: [119.850582, 34.012288],
      num: 1
    },
    {
      name: '阜宁县',
      value: [119.802271, 33.758857],
      num: 4
    },
    {
      name: '射阳县',
      value: [120.270376, 33.852258],
      num: 2
    },
    {
      name: '建湖县',
      value: [119.800073, 33.405548],
      num: 1
    },
    {
      name: '开发区',
      value: [120.222102, 33.353314],
      num: 2
    },
    {
      name: '东台市',
      value: [120.320308, 32.867845],
      num: 2
    }
    ]
  },
  {
    name: '省星级上云',
    children: [{
      name: '亭湖区',
      value: [120.431667, 33.466198],
      num: 95
    },
    {
      name: '盐都区',
      value: [120.115793, 33.282589],
      num: 191
    },
    {
      name: '大丰区',
      value: [120.639527, 33.100879],
      num: 93
    },
    {
      name: '响水县',
      value: [119.758018, 34.21264],
      num: 21
    },
    {
      name: '阜宁县',
      value: [119.701154, 33.731166],
      num: 77
    },
    {
      name: '射阳县',
      value: [120.257673, 33.639881],
      num: 17
    },
    {
      name: '建湖县',
      value: [119.907876, 33.56175],
      num: 24
    },
    {
      name: '开发区',
      value: [120.253344, 33.356325],
      num: 17
    },
    {
      name: '东台市',
      value: [120.559947, 32.718202],
      num: 154
    },
    {
      name: '盐南高新区',
      value: [120.202434, 33.304047],
      num: 22
    }
    ]
  },
  {
    name: '数字化诊断',
    children: [{
      name: '亭湖区',
      value: [120.202063, 33.4491],
      num: 14
    },
    {
      name: '盐都区',
      value: [120.038058, 33.237038],
      num: 21
    },
    {
      name: '大丰区',
      value: [120.531875, 33.115202],
      num: 17
    },
    {
      name: '响水县',
      value: [119.68974, 34.171789],
      num: 3
    },
    {
      name: '滨海县',
      value: [120.168156, 34.11752],
      num: 9
    },
    {
      name: '阜宁县',
      value: [119.602099, 33.651326],
      num: 8
    },
    {
      name: '射阳县',
      value: [120.50776, 33.72055],
      num: 7
    },
    {
      name: '建湖县',
      value: [119.815438, 33.505086],
      num: 7
    },
    {
      name: '开发区',
      value: [120.232144, 33.341698],
      num: 20
    },
    {
      name: '东台市',
      value: [120.658138, 32.808566],
      num: 44
    },
    {
      name: '盐南高新区',
      value: [120.13068, 33.288981],
      num: 5
    }
    ]
  }
  ]
})

Mock.mock('/middle-bottom-two', {
  colors: [{
    color: 'rgb(250,105,0)',
    bg: 'rgba(250,105,0,0.3)'
  },
  {
    color: 'rgb(42,185,189)',
    bg: 'rgba(42,185,189,0.3)'
  },
  {
    color: 'rgb(0,187,131);',
    bg: 'rgba(0,187,131,0.3)'
  },
  {
    color: 'rgb(179,149,12)',
    bg: 'rgba(179,149,12,0.3)'
  },
  {
    color: 'rgb(82,114,191)',
    bg: 'rgba(82,114,191,0.3)'
  }
  ],
  theader: [{
    name: '省星级上云'
  },
  {
    name: '省示范智能车间'
  },
  {
    name: '省示范智能工厂'
  },
  {
    name: '工业互联网标杆工厂'
  },
  {
    name: '重点工业互联网平台'
  }
  ],
  demandLinkList: [
    {
      name: '弹簧',
      num: '8000件',
      area: ' 广东 深圳',
      time: '2022-10-29'
    },
    {
      name: '304不锈钢开槽垫片',
      num: '20000只',
      area: ' 江苏 扬州',
      time: '2022-10-31'
    },
    {
      name: '铝手柄加工',
      num: '400件',
      area: '江苏 盐城',
      time: '2022-11-03'
    },
    {
      name: '304 616L零割不锈钢板',
      num: '30吨',
      area: ' 山东 聊城 ',
      time: '2022-11-01'
    },
    {
      name: '古铜色合金扣',
      num: '5000套',
      area: ' 上海市',
      time: '2022-10-31'
    },
    {
      name: '求购图片所示太阳能路灯1350套出口用',
      num: '1350套',
      area: ' 广东 深圳',
      time: '2022-10-31'
    },
    {
      name: '批加工中心或车铣复合车床304不锈钢零件外发加工',
      num: '1000件',
      area: ' 江苏 盐城',
      time: '2022-10-25'
    },
    {
      name: '车加工滚花件',
      num: '40000件',
      area: ' 上海市',
      time: '2022-10-28'
    },
    {
      name: 'BCD安全阀 泄气阀',
      num: '2000个',
      area: ' 广东 深圳',
      time: '2022-10-25'
    },
    {
      name: '喷气织机专用电磁阀',
      num: '1000000件',
      area: ' 江苏 江阴',
      time: '2022-10-20'
    },
    {
      name: '机加工冲压件',
      num: '15000件',
      area: ' 江苏 江阴',
      time: '2022-10-20'
    },
    {
      name: '450铸铁精密铸造',
      num: '30000件',
      area: ' 江苏 江阴',
      time: '2022-10-11'
    },
    {
      name: '模具限位夹',
      num: '1500只',
      area: ' 浙江 宁波',
      time: '2022-10-21'
    },
    {
      name: '镀锌U型管卡',
      num: '7165套',
      area: ' 浙江 宁波',
      time: '2022-10-21'
    },
    {
      name: '304加工',
      num: '1800个',
      area: ' 浙江 嘉兴',
      time: '2022-10-21'
    },
    {
      name: '非标安全销',
      num: '100000个',
      area: ' 江苏 江阴',
      time: '2022-10-11'
    },
    {
      name: '齿轮加工',
      num: '94件',
      area: '江苏 镇江',
      time: '2022-10-25'
    },
    {
      name: '不锈钢铸件寻厂家',
      num: '10000件',
      area: '江苏 昆山',
      time: '2022-10-25'
    },
    {
      name: '外发外发五金冲压小模具加工五外发五金冲压小模具加工金冲压小模具加工',
      num: '10件',
      area: '江苏 无锡',
      time: '2022-10-26'
    },
    {
      name: '反重力模型摆杆摇杆加工',
      num: '600个',
      area: '浙江 金华',
      time: '2022-10-26'
    },
    {
      name: '求购QAL10-4-4铝青铜',
      num: '20片',
      area: '安徽 马鞍山',
      time: '2022-10-26'
    },
    {
      name: '铝件加工',
      num: '500件',
      area: '河北 沧州',
      time: '2022-10-27'
    },
    {
      name: '普通碳钢.表面镀钻砂粒800#',
      num: '10000件',
      area: '江苏 昆山',
      time: '2022-10-27'
    },
    {
      name: '螺栓螺母加工',
      num: '20000套',
      area: '江苏',
      time: '2022-10-28'
    },
    {
      name: '注塑模具制作及产品注塑加工',
      num: '10副',
      area: '上海',
      time: '2022-10-28'
    },
    {
      name: '异型片机加工磨床铣床加工',
      num: '900个',
      area: '浙江 金华',
      time: '2022-10-29'
    },
    {
      name: '加厚六角螺母',
      num: '40只',
      area: '浙江 宁波',
      time: '2022-10-30'
    },
    {
      name: '国标不锈钢法兰模锻厂家',
      num: '10000',
      area: '江苏 无锡',
      time: '2022-10-30'
    },
    {
      name: '线编织管',
      num: '10000米',
      area: '江苏 无锡',
      time: '2022-10-01'
    },
    {
      name: '开关按键类： 塑胶喷油镭雕加工',
      num: '100000PCS',
      area: '广东 惠州',
      time: '2022-10-01'
    },
    {
      name: '振动盘',
      num: '16套',
      area: '广东 深圳',
      time: '2022-10-02'
    },
    {
      name: '不锈钢发热管加工',
      num: '1500',
      area: '广东 深圳',
      time: '2022-10-02'
    },
    {
      name: '灰铁/生铁 铸造',
      num: '20000吨',
      area: '山西 晋中',
      time: '2022-10-03'
    },
    {
      name: '采购304不锈钢 紧固件',
      num: '200000件',
      area: '河北 保定',
      time: '2022-10-04'
    },
    {
      name: '邦定加工',
      num: '1000件',
      area: '广东 中山',
      time: '2022-10-05'
    },
    {
      name: '弧形磁铁',
      num: '100000粒',
      area: '广东 东莞',
      time: '2022-10-05'
    },
    {
      name: '加厚六角螺母',
      num: '528只',
      area: '浙江 宁波',
      time: '2022-10-07'
    },
    {
      name: '空心管6071/T5',
      num: '5000PCS',
      area: '江苏 苏州',
      time: '2022-10-31'
    },
    {
      name: '不锈钢冲压工厂',
      num: '1200件',
      area: '广东 广州',
      time: '2022-10-31'
    },
    {
      name: '不锈钢车件加工开发PS25（不锈钢： 上盖316材质 )',
      num: '5000个',
      area: '广东 惠州',
      time: '2022-10-31'
    },
    {
      name: '求购拉杆箱拖轮和配套固定PE板',
      num: '2000个',
      area: '山东 潍坊',
      time: '2022-10-31'
    },
    {
      name: '8字铝扣长度12mm套（2.5钢丝绳）50万粒',
      num: '500000粒',
      area: '浙江 温州',
      time: '2022-10-31'
    },
    {
      name: '注塑模具制作及产品注塑加工',
      num: '10付',
      area: '山东 临沂',
      time: '2022-11-15'
    },
    {
      name: 'PU革 复海绵 10000套 寻求优质供应商长期合作',
      num: '10000套',
      area: '浙江 永康',
      time: '2022-11-15'
    },
    {
      name: '寻找长期合作红冲件供应商',
      num: '1000',
      area: '浙江 宁波',
      time: '2022-11-15'
    },
    {
      name: '注塑件外协加工',
      num: '10000',
      area: '浙江 宁波',
      time: '2022-11-15'
    },
    {
      name: '寻求有走心机加工的厂家合作',
      num: '3000000只',
      area: '浙江 丽水',
      time: '2022-11-15'
    },
    {
      name: '圆柱销调节轴液压润滑原件五金件加工',
      num: '12000只',
      area: '江苏 盐城',
      time: '2022-11-20'
    },
    {
      name: '注塑模具制作及产品注塑加工',
      num: '10付',
      area: '山东 临沂',
      time: '2022-11-20'
    },
    {
      name: '螺栓及丝杠加工',
      num: '500',
      area: '山东 泰安',
      time: '2022-11-20'
    },
    {
      name: '截止阀阀杆，T型螺纹轴',
      num: '1000件',
      area: '浙江 宁波',
      time: '2022-11-23'
    },
    {
      name: '接水管件配套产品询找现货',
      num: '4000件',
      area: '浙江 宁波',
      time: '2022-11-23'
    },
    {
      name: '空心轴加工',
      num: '90000根',
      area: '江苏 无锡',
      time: '2022-11-24'
    },
    {
      name: '采购临西轴承，碳钢轴承',
      num: '180000套',
      area: '浙江 温州',
      time: '2022-11-25'
    },
    {
      name: '车加工件询价',
      num: '4000套',
      area: '上海 松江',
      time: '2022-11-25'
    },
    {
      name: '注塑模具制作及产品注塑加工',
      num: '10付',
      area: '山东 临沂',
      time: '2022-11-24'
    },
    {
      name: '求购六角螺母 5/16-18 详细看图纸',
      num: '20万件',
      area: '浙江 嘉兴',
      time: '2022-11-24'
    },
    {
      name: '聚四氟乙烯板加工',
      num: '300块',
      area: '浙江 宁波',
      time: '2022-11-24'
    },
    {
      name: '实单 | 询求东莞市铅笔刀/刨刀片制作加工厂家 长期订单',
      num: '长期',
      area: '广东 东莞',
      time: '2022-11-24'
    },
    {
      name: '901855电池',
      num: '5000套',
      area: '广东 东莞',
      time: '2022-11-25'
    },
    {
      name: '注塑模具加工',
      num: '14套',
      area: '江苏 无锡',
      time: '2022-11-25'
    },
    {
      name: '304L不锈钢板采购',
      num: '300吨',
      area: '河北 沧州',
      time: '2022-11-25'
    },
    {
      name: '冲压加工五金固定开口销',
      num: '10000件',
      area: '河北 邢台',
      time: '2022-11-25'
    },
    {
      name: '电镀金刚石磨针',
      num: '100套',
      area: '江苏 江阴',
      time: '2022-11-25'
    }, {
      name: '电镀金刚石磨针',
      num: '100套',
      area: '江苏 江阴',
      time: '2022-11-26'
    }, {
      name: '冲压加工五金固定开口销',
      num: '10000件',
      area: '河北 邢台',
      time: '2022-11-26'
    }, {
      name: '304L不锈钢板采购',
      num: '300吨',
      area: '河北 沧州',
      time: '2022-11-26'
    }, {
      name: '环保开关接地触头',
      num: '200个',
      area: '江苏 常州',
      time: '2022-11-26'
    }, {
      name: '注塑模具加工',
      num: '14套',
      area: '江苏 无锡',
      time: '2022-11-26'
    }, {
      name: '901855电池',
      num: '5000套',
      area: '广东 东莞',
      time: '2022-11-26'
    }, {
      name: '求购六角螺母',
      num: '20万件',
      area: '浙江 嘉兴',
      time: '2022-11-26'
    }, {
      name: '注塑模具制作及产品注塑加工',
      num: '10付',
      area: '山东 临沂',
      time: '2022-11-27'
    }, {
      name: '车加工件询价',
      num: '4000套',
      area: '上海 松江',
      time: '2022-11-27'
    }, {
      name: '空心轴加工',
      num: '90000根',
      area: '江苏 无锡',
      time: '2022-11-27'
    }, {
      name: '截止阀阀杆，T型螺纹轴',
      num: '1000件',
      area: '浙江 宁波',
      time: '2022-11-27'
    }, {
      name: '圆柱销调节轴液压润滑原件五金件加工',
      num: '12000只',
      area: '江苏 盐城',
      time: '2022-11-27'
    }, {
      name: '注塑件外协加工',
      num: '10000套',
      area: '浙江 宁波',
      time: '2022-11-27'
    }, {
      name: '注塑模具制作及产品注塑加工',
      num: '10付',
      area: '山东 临沂',
      time: '2022-11-27'
    }, {
      name: '8字铝扣长度12mm套（2.5钢丝绳）',
      num: '500000粒',
      area: '浙江 温州',
      time: '2022-11-27'
    }, {
      name: '拉杆箱拖轮和配套固定PE板',
      num: '2000个',
      area: '山东 潍坊',
      time: '2022-11-28'
    }, {
      name: '不锈钢车件加工开发PS25',
      num: '5000个',
      area: '广东 惠州',
      time: '2022-11-28'
    }, {
      name: '不锈钢冲压',
      num: '1200件',
      area: '广东 广州',
      time: '2022-11-28'
    }, {
      name: '空心管6071/T5',
      num: '5000PCS',
      area: '江苏 苏州',
      time: '2022-11-28'
    }, {
      name: '空心管6071/T5',
      num: '5000PCS',
      area: '江苏 苏州',
      time: '2022-11-29'
    }, {
      name: '加厚六角螺母',
      num: '528只',
      area: '浙江 宁波',
      time: '2022-11-29'
    }, {
      name: '邦定加工',
      num: '1000件',
      area: '广东 中山',
      time: '2022-11-29'
    }, {
      name: '采购304不锈钢 紧固件',
      num: '200000件',
      area: '河北 保定',
      time: '2022-11-30'
    }, {
      name: '不锈钢发热管加工',
      num: '5000个',
      area: '广东 广州',
      time: '2022-11-30'
    }, {
      name: '国标不锈钢法兰模锻',
      num: '10000',
      area: '江苏 无锡',
      time: '2022-11-30'
    }, {
      name: '异型片机加工磨床铣床加工',
      num: '900个',
      area: '浙江 金华',
      time: '2022-11-30'
    }, {
      name: '注塑模具制作及产品注塑加工',
      num: '10副',
      area: '浙江 金华',
      time: '2022-11-30'
    }, {
      name: '螺栓螺母加工',
      num: '20000套',
      area: '江苏',
      time: '2022-11-31'
    }, {
      name: '不锈钢铸件',
      num: '10000件',
      area: '江苏 昆山',
      time: '2022-11-31'
    }, {
      name: '齿轮加工',
      num: '94件',
      area: '江苏 镇江',
      time: '2022-11-31'
    }, {
      name: '空心轴加工',
      num: '90000根',
      area: '江苏 江阴',
      time: '2022-11-31'
    }, {
      name: '铁路闸瓦钎子加工',
      num: '1500件',
      area: '河北 邢台',
      time: '2022-11-31'
    }, {
      name: '螺丝配件加工',
      num: '6000个',
      area: '广东 潮州',
      time: '2022-10-29'
    }
  ],

  data: [{
    pingtai: '盐都区',
    biaogan: '盐都区',
    gongchang: '盐都区/开发区',
    chejian: '大丰区',
    shangyun: '盐都区'

  }, {
    pingtai: '亭湖区',
    biaogan: '亭湖区/阜宁县',
    gongchang: '',
    chejian: '亭湖区/开发区',
    shangyun: '亭湖区/开发区'
  }, {
    pingtai: '东台市',
    biaogan: '大丰区',
    gongchang: '-',
    chejian: '-',
    shangyun: '-'
  }, {
    pingtai: '大丰区',
    biaogan: '射阳县/开发区/东台市',
    gongchang: '-',
    chejian: '-',
    shangyun: '-'
  }, {
    pingtai: '阜宁县',
    biaogan: '滨海县/建湖县',
    gongchang: '-',
    chejian: '-',
    shangyun: '-'
  }]
})

Mock.mock('/right-top-two', {
  value: {
    money: '1.5亿元',
    hardware: '1:2'
  },
  data: [{
    name: '电子',
    value: 43.64
  },
  {
    name: '汽车',
    value: 46.67
  },
  {
    name: '钢铁',
    value: 50
  },
  {
    name: '新能源',
    value: 40
  },
  {
    name: '机械',
    value: 43.21
  },
  {
    name: '纺织',
    value: 46.67
  },
  {
    name: '化工',
    value: 50
  },
  {
    name: '医药',
    value: 40
  },
  {
    name: '石化',
    value: 40
  },
  {
    name: '高新技术',
    value: 40
  },
  {
    name: '新材料',
    value: 40
  },
  {
    name: '建材',
    value: 46.67
  },
  {
    name: '其他',
    value: 42.7
  }
  ]
})

Mock.mock('/right-middle-two', {
  data: [{
    img: '/static/img/qy@3x.png',
    name: '省星级上云',
    num: '427'
    // desc: '12%'
  },
  {
    img: '/static/img/ssf@3x.png',
    name: '省示范智能工厂',
    num: '15'
    // desc: '50%'
  },
  {
    img: '/static/img/zdgy@3x.png',
    name: '省重点工业互联网平台',
    num: '3'
    // desc: '25%'
  },
  {
    img: '/static/img/xssz@3x.png',
    name: '线上数字化诊断',
    num: '3609',
    desc: ''
  },
  {
    img: '/static/img/gyhlw@3x.png',
    name: '工业互联网标杆工厂',
    num: '4'
    // desc: '40%'
  },
  {
    img: '/static/img/xssz@3x.png',
    name: '专家现场数字化诊断',
    num: '1294',
    desc: ''
  }
  ]
})

// Mock.mock('/right-bottom-two', {
//   data: [{
//     img: '/static/img/xy1@3x.png',
//     name: "工业互联网",
//     num: '6',
//     desc: '场'
//   },
//   {
//     img: '/static/img/xy2@3x.png',
//     name: "数字化转型",
//     num: '5',
//     desc: '场'
//   },
//   {
//     img: '/static/img/xy3@3x.png',
//     name: "精益智造",
//     num: '5',
//     desc: '场'
//   },
//   {
//     img: '/static/img/xy4@3x.png',
//     name: "工业机器人应用",
//     num: '6',
//     desc: '场'
//   },
//   {
//     img: '/static/img/xy5@3x.png',
//     name: "智能智造技术",
//     num: '7',
//     desc: '场'
//   },
//   {
//     img: '/static/img/xy6@3x.png',
//     name: "数据治理",
//     num: '5',
//     desc: '场'
//   },
//   {
//     img: '/static/img/xy7@3x.png',
//     name: "智能制造成熟度",
//     num: '6',
//     desc: '场'
//   },
//   {
//     img: '/static/img/xy8@3x.png',
//     name: "标杆游学",
//     num: '8',
//     desc: '场'
//   }
//   ]
// });
Mock.mock('/right-bottom-two', {
  data: [{
    img: '/static/img/xy1@3x.png',
    name: '精益智能制造',
    num: '1741',
    desc: '场'
  },
  {
    img: '/static/img/xy2@3x.png',
    name: '企业经营管理',
    num: '902',
    desc: '场'
  },
  {
    img: '/static/img/xy3@3x.png',
    name: '工业机器人实训',
    num: '1436',
    desc: '场'
  },
  {
    img: '/static/img/xy4@3x.png',
    name: 'PLC应用技术',
    num: '1964',
    desc: '场'
  },
  {
    img: '/static/img/xy5@3x.png',
    name: '职业技能等级提升',
    num: '5584',
    desc: '场'
  },
  {
    img: '/static/img/xy6@3x.png',
    name: '数字化新职业',
    num: '1188',
    desc: '场'
  },
  {
    img: '/static/img/xy7@3x.png',
    name: '企业定制化内训',
    num: '2328',
    desc: '场'
  },
  {
    img: '/static/img/xy8@3x.png',
    name: '标杆游学',
    num: '898',
    desc: '场'
  }
  ]
})
